import { Component, ViewEncapsulation } from '@angular/core';
import { IconMapper } from '../../helpers/icon-mapper';

@Component({
       selector: 'cfa-button',
    templateUrl: './button.html',
    styleUrls: ['../../../styles/styles.scss', './button.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CfaButton extends IconMapper {
    icon = 'Menu';

    constructor() {
        super();
    }

}
